import { configureStore } from "@reduxjs/toolkit";
import navSidebarReducer from "../Reducer/NavSidebarSlice";
import ModalReducer from "../Reducer/ModalSlice";
import DataReducer from "../Reducer/DataSlice";
import OrderReducer from "../Reducer/OrderSlice";
import ImplantReducer from "../Reducer/ImplantSlice";

const store = configureStore({
  reducer: {
    NavSidebar: navSidebarReducer,
    Modal: ModalReducer,
    Data: DataReducer,
    Order: OrderReducer,
    Implant: ImplantReducer,
  },
});

export default store;
